@if (surveyEnabled) {
  <div class="m-b-12">
    <mc-notification
      appearance="info"
      actionsposition="right"
      verticalalign="middle"
      icon="thumbs-up"
      fit="small"
      heading="Share your feedback!"
      body="Tell us how we are doing.">
      <span slot="actions" class="mc-notification__actions">
        <mc-button fit="small" appearance="neutral" (click)="openSurvey()">Start Survey</mc-button>
      </span>
    </mc-notification>
  </div>
}
<form [formGroup]="filterFormGroup" class="list-work-order-container">
  <div class="pure-g" style="align-items: center">
    <div class="pure-u-md-10-24 pure-u-lg-14-24">
      <h3 class="inline m-r-4" i18n>Work Orders</h3>
    </div>
    <div class="pure-u-md-14-24 pure-u-lg-10-24" style="display: flex; flex-direction: row-reverse">
      <app-search class="search-bar" [workOrderSearchTextForm]="filterFormGroup.controls.workOrderSearchTextForm"></app-search>
    </div>
  </div>

  <app-filters [filterFormGroup]="filterFormGroup" [isAnyRowSelected]="isAnyRowSelected" [selectedRows]="selectedRows"></app-filters>
  <app-work-order-grid
    [filterFormGroup]="filterFormGroup"
    class="table-container"
    (selectedRowsChange)="handleSelectedRows($event)"></app-work-order-grid>
</form>
